import { OrganizerForm } from 'modules/organizer/ui/components/organizer-form';
import { SkeletonOrganizerForm } from 'modules/organizer/ui/components/organizer-form/skeleton-organizer-form';
import { useProfileForm } from 'modules/settings/ui/hooks';
import React from 'react';

function Profile() {
  const { initialValues, isLoading, isSaving, handleSubmit } = useProfileForm();

  if (isLoading) {
    return <SkeletonOrganizerForm />;
  }

  return <OrganizerForm isLoading={isSaving} initialValues={initialValues} onSubmit={handleSubmit} />;
}

export default Profile;
